import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './timerRing.css';


export default class TimerRing extends Component {

  render() {

    let cssClass = 'timer-ring';

    if (this.props.enabled) {
      cssClass += ' timer-ring--enabled';
    }

    if (this.props.paused) {
      cssClass += ' timer-ring--paused';
    }

    if (!this.props.enabled && !this.props.paused) {
      cssClass += ' timer-ring--start';
    }

    return (
      <div className={cssClass}>
        <div className='timer-ring__slot'>
          <div className='timer-ring__lt' />
        </div>
        <div className='timer-ring__slot'>
          <div className='timer-ring__rt' />
        </div>
      </div>
    );
  }
}

TimerRing.propTypes = {
  paused: PropTypes.bool,
  enabled: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/timer-ring/timerRing.js